import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Gain } from "../core/context/Gain";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { noOp } from "../core/util/Interface";
import { assert } from "../core/util/Debug";
/**
 * Base class for fire-and-forget nodes
 */

export var OneShotSource = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(OneShotSource, _ToneAudioNode);

  var _super = _createSuper(OneShotSource);

  function OneShotSource(options) {
    var _this;

    _classCallCheck(this, OneShotSource);

    _this = _super.call(this, options);
    /**
     * The callback to invoke after the
     * source is done playing.
     */

    _this.onended = noOp;
    /**
     * The start time
     */

    _this._startTime = -1;
    /**
     * The stop time
     */

    _this._stopTime = -1;
    /**
     * The id of the timeout
     */

    _this._timeout = -1;
    /**
     * The public output node
     */

    _this.output = new Gain({
      context: _this.context,
      gain: 0
    });
    /**
     * The output gain node.
     */

    _this._gainNode = _this.output;
    /**
     * Get the playback state at the given time
     */

    _this.getStateAtTime = function (time) {
      var computedTime = this.toSeconds(time);

      if (this._startTime !== -1 && computedTime >= this._startTime && (this._stopTime === -1 || computedTime <= this._stopTime)) {
        return "started";
      } else {
        return "stopped";
      }
    };

    _this._fadeIn = options.fadeIn;
    _this._fadeOut = options.fadeOut;
    _this._curve = options.curve;
    _this.onended = options.onended;
    return _this;
  }

  _createClass(OneShotSource, [{
    key: "_startGain",
    value:
    /**
     * Start the source at the given time
     * @param  time When to start the source
     */
    function _startGain(time) {
      var gain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      assert(this._startTime === -1, "Source cannot be started more than once"); // apply a fade in envelope

      var fadeInTime = this.toSeconds(this._fadeIn); // record the start time

      this._startTime = time + fadeInTime;
      this._startTime = Math.max(this._startTime, this.context.currentTime); // schedule the envelope

      if (fadeInTime > 0) {
        this._gainNode.gain.setValueAtTime(0, time);

        if (this._curve === "linear") {
          this._gainNode.gain.linearRampToValueAtTime(gain, time + fadeInTime);
        } else {
          this._gainNode.gain.exponentialApproachValueAtTime(gain, time, fadeInTime);
        }
      } else {
        this._gainNode.gain.setValueAtTime(gain, time);
      }

      return this;
    }
    /**
     * Stop the source node at the given time.
     * @param time When to stop the source
     */

  }, {
    key: "stop",
    value: function stop(time) {
      this.log("stop", time);

      this._stopGain(this.toSeconds(time));

      return this;
    }
    /**
     * Stop the source at the given time
     * @param  time When to stop the source
     */

  }, {
    key: "_stopGain",
    value: function _stopGain(time) {
      var _this2 = this;

      assert(this._startTime !== -1, "'start' must be called before 'stop'"); // cancel the previous stop

      this.cancelStop(); // the fadeOut time

      var fadeOutTime = this.toSeconds(this._fadeOut); // schedule the stop callback

      this._stopTime = this.toSeconds(time) + fadeOutTime;
      this._stopTime = Math.max(this._stopTime, this.context.currentTime);

      if (fadeOutTime > 0) {
        // start the fade out curve at the given time
        if (this._curve === "linear") {
          this._gainNode.gain.linearRampTo(0, fadeOutTime, time);
        } else {
          this._gainNode.gain.targetRampTo(0, fadeOutTime, time);
        }
      } else {
        // stop any ongoing ramps, and set the value to 0
        this._gainNode.gain.cancelAndHoldAtTime(time);

        this._gainNode.gain.setValueAtTime(0, time);
      }

      this.context.clearTimeout(this._timeout);
      this._timeout = this.context.setTimeout(function () {
        // allow additional time for the exponential curve to fully decay
        var additionalTail = _this2._curve === "exponential" ? fadeOutTime * 2 : 0;

        _this2._stopSource(_this2.now() + additionalTail);

        _this2._onended();
      }, this._stopTime - this.context.currentTime);
      return this;
    }
    /**
     * Invoke the onended callback
     */

  }, {
    key: "_onended",
    value: function _onended() {
      var _this3 = this;

      if (this.onended !== noOp) {
        this.onended(this); // overwrite onended to make sure it only is called once

        this.onended = noOp; // dispose when it's ended to free up for garbage collection only in the online context

        if (!this.context.isOffline) {
          var disposeCallback = function disposeCallback() {
            return _this3.dispose();
          }; // @ts-ignore


          if (typeof window.requestIdleCallback !== "undefined") {
            // @ts-ignore
            window.requestIdleCallback(disposeCallback);
          } else {
            setTimeout(disposeCallback, 1000);
          }
        }
      }
    }
    /**
     * Get the playback state at the current time
     */

  }, {
    key: "state",
    get: function get() {
      return this.getStateAtTime(this.now());
    }
    /**
     * Cancel a scheduled stop event
     */

  }, {
    key: "cancelStop",
    value: function cancelStop() {
      this.log("cancelStop");
      assert(this._startTime !== -1, "Source is not started"); // cancel the stop envelope

      this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime);

      this.context.clearTimeout(this._timeout);
      this._stopTime = -1;
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(OneShotSource.prototype), "dispose", this).call(this);

      this._gainNode.disconnect();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        curve: "linear",
        fadeIn: 0,
        fadeOut: 0,
        onended: noOp
      });
    }
  }]);

  return OneShotSource;
}(ToneAudioNode);